import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {ApiResponseSchedule} from "features/model/types/groups/schedule/scheduleSchema";
import {loginReducer} from "features/model/slice/lodinSlice";
import {ScheduleUserResponse} from "features/model/types/groups/schedule/scheduleUserSchema";


export const fetchScheduleUsers = createAsyncThunk(
    "lessons/fetchScheduleUsers",
    async (_, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get<ScheduleUserResponse>('/api/schedule/users', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );


            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
